/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, date: NonNullable<unknown> }} Misc_Downloads_Versionpublished1Inputs */

const id_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versi ${i?.version} - Diterbitkan pada ${i?.date}`)
};

const ms_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versi ${i?.version} - Diterbitkan pada ${i?.date}`)
};

const da_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} - Udgivet den ${i?.date}`)
};

const de_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} - Veröffentlicht am ${i?.date}`)
};

const en_us2_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} - Published on ${i?.date}`)
};

const es_es2_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.version} - Publicada el ${i?.date}`)
};

const es_mx2_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión ${i?.version} - Publicada el ${i?.date}`)
};

const fil_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bersyon ${i?.version} - Nai-publish noong ${i?.date}`)
};

const fr_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} — Publiée le ${i?.date}`)
};

const it_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versione ${i?.version} - Pubblicata il ${i?.date}`)
};

const hu_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} verzió - Közzétéve: ${i?.date}`)
};

const nl_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versie ${i?.version} - Gepubliceerd op ${i?.date}`)
};

const no_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versjon ${i?.version} - Publisert ${i?.date}`)
};

const pl_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wersja ${i?.version} - Opublikowana ${i?.date}`)
};

const pt_br2_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version} - Publicada em ${i?.date}`)
};

const pt_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão ${i?.version} - Publicada em ${i?.date}`)
};

const ro_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versiunea ${i?.version} - Publicată pe ${i?.date}`)
};

const fi_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versio ${i?.version} - Julkaistu ${i?.date}`)
};

const sv_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version} - Publicerad ${i?.date}`)
};

const vi_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phiên bản ${i?.version} - Đã phát hành vào ${i?.date}`)
};

const tr_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sürüm ${i?.version} - ${i?.date} tarihinde yayınlandı`)
};

const cs_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verze ${i?.version} - Vydáno ${i?.date}`)
};

const bg_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Версия ${i?.version} - Публикувана на ${i?.date}`)
};

const ru_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Версия ${i?.version} — Опубликована ${i?.date}`)
};

const uk_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Версія ${i?.version} — Опубліковано ${i?.date}`)
};

const ar_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الإصدار ${i?.version} - نُشر في ${i?.date}`)
};

const hi_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संस्करण ${i?.version} - ${i?.date} को प्रकाशित`)
};

const th_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เวอร์ชัน ${i?.version} - เผยแพร่เมื่อ ${i?.date}`)
};

const ja_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`バージョン ${i?.version} - ${i?.date} 公開`)
};

const zh_cn2_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`版本 ${i?.version} - 发布于 ${i?.date}`)
};

const zh_hant1_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`版本 ${i?.version} - 發布於 ${i?.date}`)
};

const ko_misc_downloads_versionpublished1 = /** @type {(inputs: Misc_Downloads_Versionpublished1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`버전 ${i?.version} - ${i?.date}에 게시됨`)
};

/**
* | output |
* | --- |
* | "Version {version} - Published on {date}" |
*
* @param {Misc_Downloads_Versionpublished1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_versionpublished1 = /** @type {((inputs: Misc_Downloads_Versionpublished1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Versionpublished1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_versionpublished1(inputs)
	if (locale === "ms") return ms_misc_downloads_versionpublished1(inputs)
	if (locale === "da") return da_misc_downloads_versionpublished1(inputs)
	if (locale === "de") return de_misc_downloads_versionpublished1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_versionpublished1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_versionpublished1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_versionpublished1(inputs)
	if (locale === "fil") return fil_misc_downloads_versionpublished1(inputs)
	if (locale === "fr") return fr_misc_downloads_versionpublished1(inputs)
	if (locale === "it") return it_misc_downloads_versionpublished1(inputs)
	if (locale === "hu") return hu_misc_downloads_versionpublished1(inputs)
	if (locale === "nl") return nl_misc_downloads_versionpublished1(inputs)
	if (locale === "no") return no_misc_downloads_versionpublished1(inputs)
	if (locale === "pl") return pl_misc_downloads_versionpublished1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_versionpublished1(inputs)
	if (locale === "pt") return pt_misc_downloads_versionpublished1(inputs)
	if (locale === "ro") return ro_misc_downloads_versionpublished1(inputs)
	if (locale === "fi") return fi_misc_downloads_versionpublished1(inputs)
	if (locale === "sv") return sv_misc_downloads_versionpublished1(inputs)
	if (locale === "vi") return vi_misc_downloads_versionpublished1(inputs)
	if (locale === "tr") return tr_misc_downloads_versionpublished1(inputs)
	if (locale === "cs") return cs_misc_downloads_versionpublished1(inputs)
	if (locale === "bg") return bg_misc_downloads_versionpublished1(inputs)
	if (locale === "ru") return ru_misc_downloads_versionpublished1(inputs)
	if (locale === "uk") return uk_misc_downloads_versionpublished1(inputs)
	if (locale === "ar") return ar_misc_downloads_versionpublished1(inputs)
	if (locale === "hi") return hi_misc_downloads_versionpublished1(inputs)
	if (locale === "th") return th_misc_downloads_versionpublished1(inputs)
	if (locale === "ja") return ja_misc_downloads_versionpublished1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_versionpublished1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_versionpublished1(inputs)
	return ko_misc_downloads_versionpublished1(inputs)
});
export { misc_downloads_versionpublished1 as "misc.downloads.versionPublished" }